import React from 'react';
import styled from 'styled-components';
import {
  brandColours,
  fontSize,
  minBreakpointQuery,
  sectionMargins,
  standardColours,
} from '../styles';
import { Container } from './ui';

const StyledBlogTableOfContents = styled.section`
  ${sectionMargins('20px', '40px')};
`;

const StyledContainer = styled(Container)`
  padding-left: 0;
  padding-right: 0;
`;

const StyledContents = styled.div`
  background-color: ${standardColours.lightestGrey};
  padding: 30px;

  ${minBreakpointQuery.small`
    padding: 40px;
  `}

  ${minBreakpointQuery.medium`
    padding: 50px;
  `}

  ${minBreakpointQuery.large`
    padding: 60px;
  `}
`;

const StyledHeading = styled.h2`
  ${fontSize(16)};
  margin-bottom: 20px;

  ${minBreakpointQuery.small`
    ${fontSize(18)};
  `}

  ${minBreakpointQuery.large`
    ${fontSize(20)};
  `}
`;

const StyledLinks = styled.ul`
  display: grid;
  gap: 20px;
`;

const StyledLinkItem = styled.li``;

const StyledLink = styled.a`
  color: ${brandColours.quaternary};

  ${minBreakpointQuery.small`
    ${fontSize(18)};
  `}

  ${minBreakpointQuery.large`
    ${fontSize(20)};
  `}
`;

const BlogTableOfContents = ({ anchorLinks }) =>
  anchorLinks.length > 0 && (
    <StyledBlogTableOfContents>
      <StyledContainer narrower={true}>
        <StyledContents>
          <StyledHeading>Table of Contents</StyledHeading>
          <StyledLinks>
            {anchorLinks.map(({ text, url }, id) => (
              <StyledLinkItem key={id}>
                <StyledLink href={`#${url}`}>{text}</StyledLink>
              </StyledLinkItem>
            ))}
          </StyledLinks>
        </StyledContents>
      </StyledContainer>
    </StyledBlogTableOfContents>
  );

export default BlogTableOfContents;
